"use client";

import Link from "@/components/school/SchoolLink";
import { isSchoolPath } from "@/lib/school-routes";
import { ArrowRight, House } from "lucide-react";
import { usePathname } from "next/navigation";

type SeoHomepageNavProps = {
  currentSection: string;
};

export function SeoHomepageNav({ currentSection }: SeoHomepageNavProps) {
  const name = isSchoolPath(usePathname()) ? "Liceo Cultural Británico" : "ChickyTutor";
  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0f0f14]/95 text-white backdrop-blur">
      <nav
        aria-label={`${name} main navigation`}
        className="mx-auto flex min-h-16 max-w-6xl items-center justify-between gap-4 px-6"
      >
        <Link
          href="/"
          className="group inline-flex items-center gap-3 font-semibold text-white transition hover:text-orange-200"
        >
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-orange-500 text-black transition group-hover:bg-orange-400">
            <House className="h-4 w-4" aria-hidden="true" />
          </span>
          <span>
            <span className="block text-sm font-bold">{name}</span>
            <span className="hidden text-xs font-medium text-white/55 sm:block">
              {currentSection}
            </span>
          </span>
        </Link>

        <Link
          href="/"
          className="inline-flex min-h-10 items-center gap-2 rounded-lg bg-orange-500 px-4 text-sm font-bold text-black transition hover:bg-orange-400"
        >
          Start speaking
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </nav>
    </header>
  );
}
